import React from "react";

export const GENRES = ["Action", "Adventure", "RPG", "Shooter", "MOBA", "Battle Royale", "Strategy", "Sports", "Racing", "Puzzle", "Simulation", "Casual"];
export const PLATFORMS = ["PC", "Mobile", "Console"];

export function Chip({ on, onClick, children, testid }) {
  return (
    <button type="button" onClick={onClick} data-testid={testid}
      className={`px-3 py-1.5 rounded-full text-xs font-semibold border transition-colors ${on ? "bg-[hsl(var(--primary))] text-[hsl(var(--primary-foreground))] border-transparent" : "border-white/15 text-white/60 hover:text-white hover:border-white/30"}`}>
      {children}
    </button>
  );
}

export function TagList({ g, size = "text-xs" }) {
  const tags = [...(g.genres || []), ...(g.platforms || [])];
  if (!tags.length) return null;
  return (
    <div className="flex flex-wrap gap-2" data-testid="game-tags">
      {(g.genres || []).map((x) => <span key={x} className={`px-3 py-1 rounded-full border border-white/20 text-white/85 ${size}`} data-testid={`game-genre-${x}`}>{x}</span>)}
      {(g.platforms || []).map((x) => <span key={x} className={`px-3 py-1 rounded-full bg-white/10 text-white/70 ${size}`} data-testid={`game-platform-${x}`}>{x}</span>)}
    </div>
  );
}

export function ReviewerBadge({ rank, compact }) {
  if (!rank) return null;
  return (
    <span data-testid="top-reviewer-badge" title={`Top Reviewer #${rank} (last 30 days)`}
      className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded bg-yellow-400/15 text-yellow-400 text-[10px] font-bold uppercase tracking-wide">
      ★ {compact ? `#${rank}` : `Top Reviewer #${rank}`}
    </span>
  );
}
